import React from 'react';
import styles from './index.module.scss';
import { IconDottedLine } from '@/assets/quest';
import cx from 'clsx';
import { Loading, Tips } from '@/components';
import { QuestEstimate, QuestType } from '../../type';
import { useQuestEstimate } from './hooks';
import { formatNetworth } from '@/utils';

export const checkDrawDataValid = ({
  prize_count,
  prize_value,
}: {
  prize_count: number;
  prize_value: number;
}) => {
  return prize_count > 0 && prize_count <= 100 && Number.isInteger(prize_value / 10000);
};

export const UnitQuestFeeCard = ({
  quest,
  isActionEmpty,
}: {
  quest?: QuestType;
  isActionEmpty: boolean;
}) => {
  const { data, isLoading } = useQuestEstimate({
    quest,
    enabled: !isActionEmpty && !!quest?.actions?.length,
  });

  return (
    <div className={styles.container}>
      <div className={styles.row}>
        <div className={styles.label}>Original Unit QuestFee Per Participant</div>
        <div
          className={cx(
            styles.value,
            data?.discount_unit_fee !== data?.unit_fee && styles.invalid,
          )}>
          {isLoading ? <Loading /> : formatNetworth(data?.unit_fee)}
        </div>
      </div>
      {data?.discount?.map((i, index) => (
        <div className={styles.row} key={index}>
          <div className={styles.label}>{i?.description}</div>
          <div className={cx(styles.value, styles.discount)}>{`${i.discount}% OFF`}</div>
        </div>
      ))}
      <IconDottedLine className={styles.dotted} />
      <div className={styles.total}>
        <div className={styles.totalLabel}>
          Final Unit QuestFee Per Participant
          <Tips
            title="The total cost is calculated based on the quest tasks you’ve set and the expected number of participants.
A 5% discount on the unit QuestFee is applied for every additional 1,000 participants purchased.
The minimum price will not fall below 50% of the original unit price.
If the expected number of participants is not met after the quest concludes, the pre-charged amount for the remaining participants will be refunded to your account."
          />
        </div>
        <div className={styles.totalValue}>
          {isLoading ? <Loading /> : formatNetworth(data?.final_unit_fee)}
        </div>
      </div>
    </div>
  );
};

export const TotalFeeCard = ({
  questEstimate,
  isLoading,
  showValue,
  className,
}: {
  questEstimate?: QuestEstimate;
  isLoading?: boolean;
  showValue?: boolean;
  className?: string;
}) => {
  return (
    <div className={cx(styles.container, className)}>
      <div className={styles.row}>
        <div className={styles.label}>
          Estimated charge amount for QuestFee
          <Tips
            title={`The total cost is calculated based on the quest tasks you've set and the expected number of participants.\nA 5% price reduction of unit QuestFee for every additional 1000 participants purchased.\nThe minimum price is not less than 50% of the original unit price.\nIf the expected participation count is not met after the quest closed, the pre-charge amount for the remaining participants will be refunded to your account.`}
          />
        </div>
        <div
          className={cx(styles.value, !(showValue && questEstimate?.deposit_fee) && styles.gray)}>
          {showValue && questEstimate ? formatNetworth(questEstimate?.deposit_fee) : '$0.00'}
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.label}>
          Total Cash lucky draw amount
          <Tips title="Prize amount of cash lucky draw is set. Winners' prizes are automatically deposited into their DeBank L2 accounts." />
        </div>
        <div
          className={cx(styles.value, !(questEstimate?.luck_draw_fee && showValue) && styles.gray)}>
          {showValue && questEstimate ? formatNetworth(questEstimate?.luck_draw_fee) : '$0.00'}
        </div>
      </div>
      <div className={styles.row}>
        <div className={styles.label}>
          Basic service fee
          <Tips title="This is a fixed fee and will not be refunded after the quest launched." />
        </div>
        <div className={cx(styles.value, !(showValue && questEstimate?.base_fee) && styles.gray)}>
          {showValue && questEstimate ? formatNetworth(questEstimate?.base_fee) : '$0.00'}
        </div>
      </div>
      {/* <div className={styles.row}>
        <div className={styles.label}>
          Deposit for quest
          <Tips title="The deposit is used to prevent scams.It will be refunded within 1-3 days of quest review completion." />
        </div>
        <div className={styles.depositContainer}>
          {isNumber(questEstimate?.discount_deposit_cash) && showValue ? (
            <span className={styles.freeTag}>
              {questEstimate?.discount_deposit_cash === 0
                ? 'Free'
                : formatNetworth(questEstimate?.discount_deposit_cash)}
            </span>
          ) : null}
          <div
            className={cx(
              styles.value,
              !(questEstimate?.deposit_cash && showValue) && styles.gray,
              isNumber(questEstimate?.discount_deposit_cash) && showValue && styles.invalid,
            )}>
            {showValue && questEstimate ? formatNetworth(questEstimate?.deposit_cash) : '$0.00'}
          </div>
        </div>
      </div> */}
      <IconDottedLine className={styles.dotted} />
      <div className={styles.total}>
        <div className={styles.totalLabel}>Total</div>
        <div className={styles.totalValue}>
          {showValue ? (
            !isLoading ? (
              questEstimate ? (
                formatNetworth(questEstimate?.total_deposit)
              ) : (
                '$0.00'
              )
            ) : (
              <Loading />
            )
          ) : (
            '$0.00'
          )}
        </div>
      </div>
    </div>
  );
};
